<div class="modal-header">
    <h2 class="modal-title">{{ modalTitle | translate }}</h2>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()">
    </button>
</div>

<div class="modal-body">
    <div class="data-list-container">
        <div *ngFor="let item of dataList" class="data-list-item" HJSuppress>
            {{ item }}
        </div>
    </div>
</div>

<div class="modal-footer justify-content-end">
    <button type="button" class="btn primary-btn" (click)="closeModal()">
        {{closeButton | translate}}
    </button>
</div>